import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "@auth0/auth0-react";
import history from "./utils/history";
import { getConfig } from "./config";

import Cookies from 'js-cookie';

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

// Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
// for a full list of the available properties on the provider
const config = getConfig();

const generateSiteTracking = () => {
  const onap = Cookies.get('onap');
  let st = {};
  
  if (onap) {
    const [sl,,s] = onap.split('-');
    st = {sl, s}
  }

  try {
    return JSON.stringify(st);
  } catch (e){
    return "{}"
  }
}

generateSiteTracking()

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: window.location.origin,
    scope: config.scope,
    ...(config.audience ? { audience: config.audience } : null),
    ...(config.ui_locales ? { ui_locales: config.ui_locales } : null),
    "ext-st": window.btoa(generateSiteTracking()).replaceAll("=","")
  },
};

const root = createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    {...providerConfig}
  >
    <App />
  </Auth0Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
